class FakeSearchInput extends HTMLElement {
  constructor() {
    super();
    this.handleFocus = this.handleFocus.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleArrowMouseDown = this.handleArrowMouseDown.bind(this);
  }

  connectedCallback() {
    this.fakeInput = this.querySelector('[data-fake-input]');
    this.realInput = document.querySelector('[data-real-search-input]');
    this.drawer = document.getElementById(this.dataset.target);

    this.fakeInput?.addEventListener('focus', this.handleFocus);
    this.fakeInput?.addEventListener('focusout', this.handleFocusOut);
    this.fakeInput?.addEventListener('input', this.handleInput);
    this.fakeInput?.addEventListener('keydown', this.handleKeyDown);
    this.drawer?.addEventListener('focusout', this.handleFocusOut);
    this.drawer?.addEventListener('mousedown', this.handleArrowMouseDown);
  }

  disconnectedCallback() {
    this.fakeInput?.removeEventListener('focus', this.handleFocus);
    this.fakeInput?.removeEventListener('focusout', this.handleFocusOut);
    this.fakeInput?.removeEventListener('input', this.handleInput);
    this.fakeInput?.removeEventListener('keydown', this.handleKeyDown);
    this.drawer?.removeEventListener('focusout', this.handleFocusOut);
    this.drawer?.removeEventListener('mousedown', this.handleArrowMouseDown);
  }

  handleFocus() {
    this.drawer?.openDesktop?.(this.fakeInput);
  }

  handleArrowMouseDown(event) {
    if (event.target.closest('.splide__arrow')) {
      event.preventDefault();
    }
  }

  handleFocusOut(event) {
    const nextTarget = event.relatedTarget;
    if (
      nextTarget &&
      (nextTarget === this.fakeInput ||
        this.contains(nextTarget) ||
        this.drawer?.contains(nextTarget))
    ) {
      return;
    }

    requestAnimationFrame(() => {
      if (!this.drawer?.hasAttribute('open')) return;

      const activeElement = document.activeElement;
      const focusIsInsideSearch =
        activeElement === this.fakeInput ||
        this.contains(activeElement) ||
        this.drawer.contains(activeElement);

      if (focusIsInsideSearch) return;

      if (
        !activeElement ||
        activeElement === document.body ||
        activeElement === document.documentElement
      ) {
        return;
      }

      this.drawer.close({ causedByFocusOut: true });
    });
  }

  handleInput(event) {
    if (!this.realInput) return;

    this.realInput.value = event.target.value;
    this.realInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  handleKeyDown(event) {
    if (event.key !== 'Enter') return;

    event.preventDefault();
    this.realInput?.form?.requestSubmit();
  }
}

if (!customElements.get('fake-search-input')) {
  customElements.define('fake-search-input', FakeSearchInput);
}
